module.exports = __webpack_public_path__ + "static/media/icn_msg_sent.49eb9165.svg";